<!-- TODO: this code can be simplified more -->
<template>
	<div>
		<v-row no-gutters>
			<v-col cols="12" class="d-flex flex-column justify-center align-center">


				<div class="get-started__title">
					How to Get Started?
				</div>


				<div class="get-started__subtitle mt-2 align-center text-center">
					Earning money on Bounty Hunter made as simple as possible
				</div>





			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col cols="12">
				<div class="d-flex justify-center mt-16">
					<v-row no-gutters class="d-flex flex-row justify-center">
						<v-col cols="12" sm="6" lg="4">






							<CardLite :height="261" class="mx-5 get-started__side-card">
								<v-icon class="w-100 mt-14">
									<img :src="AppConfigs.staticImages.TASKTILE" alt="TaskTile" />
								</v-icon>
								<div align="center" class="mt-12 mb-2 get-started__card__title">Complete Quests</div>
								<div align="center" class="get-started__card__subtitle">
									You earn coins by completing quests, watching videos, creating content, and a whole
									lot more!
								</div>
							</CardLite>






						</v-col>
						<v-col cols="12" sm="6" lg="4">






							<CardLite :height="261" class="mx-5 get-started__mid-card elevation-0">
								<v-icon class="w-100 mt-14">
									<img :src="AppConfigs.staticImages.CONTROLLERICON" alt="ControllerIcon" />
								</v-icon>
								<div align="center" class="mt-12 mb-2 get-started__card__title">Play Games</div>
								<div align="center" class="get-started__card__subtitle">Play the games you love every
									day, and gain more than just entertainment—earn rewards too!
								</div>
							</CardLite>






						</v-col>
						<v-col cols="12" sm="6" lg="4">






							<CardLite :height="261" class="mx-5 get-started__side-card primary">
								<v-icon class="w-100 mt-14">
									<img :src="AppConfigs.staticImages.POUCHICON" alt="MoneyPouchIcon" />
								</v-icon>
								<div align="center" class="mt-12 mb-2 get-started__card__title">Earn Rewards</div>
								<div align="center" class="get-started__card__subtitle">Exchange your earnings for
									in-app coins, games, skins, and other valuable rewards.</div>
							</CardLite>






						</v-col>
					</v-row>
				</div>
			</v-col>
		</v-row>
	</div>
</template>



<script>

import { AppConfigs } from "@/app.configs";
import { isMobile } from "@/utils/utils.ts";
import CardLite from "@/components/Common/Card-Lite.vue";


export default {
    components: {CardLite},
  props: {
    msg: String,
  },
  setup() {
    const isMobileDevice = isMobile();
    return {
      AppConfigs,
      isMobile: isMobileDevice,
    };
  },
};

</script>
